<template>
  <div class="investMatrix">
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :items-per-page="-1"
      item-key="ExitType"
      @click:row="onRowClick"
      dense
    >
      <template v-slot:top>
        <div class="tableToolbar">
          <v-dialog persistent v-model="isDialogShown" max-width="750">
            <v-card v-if="editedItem">
              <v-card-title>
                <span class="text-h5">Edit {{ editedItem.ExitType }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col v-for="key in itemKeys" :key="key" cols="4" sm="4" md="4">
                      <v-select
                        v-model="editedItem[key]"
                        :items="actionList"
                        :label="key"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" outlined @click="onCancel"> Cancel </v-btn>
                <v-btn color="primary" depressed @click="onOk"> Ok </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </v-data-table>
    <v-footer
      padless
      fixed
      outlined
      class="pl-5 pr-5 pt-3 pb-3 footerBtnContainer"
      color="white"
      elevation="3"
    >
      <v-spacer></v-spacer>
      <div class="btnsContainer">
        <v-btn color="primary" depressed @click="processInvestMatrix">Save</v-btn>
      </div>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: 'InvestMatrix2',
  data() {
    return {
      loading: false,
      headers: [],
      items: [],
      investMatrix: [],
      isDialogShown: false,
      selectedItem: null,
      editedItem: null,
      itemKeys: [],
      actionList: ['', 'Sell', 'Retain', 'Hold'],
    };
  },
  created() {
    this.getMatrix();
  },
  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
  },
  methods: {
    onRowClick(item) {
      console.log(item);
      this.selectedItem = item;
      this.editedItem = { ...item };
      this.isDialogShown = true;
    },
    onCancel() {
      this.editedItem = null;
      this.selectedItem = null;
      this.isDialogShown = false;
    },
    onOk() {
      Object.keys(this.selectedItem).forEach((key) => {
        this.selectedItem[key] = this.editedItem[key];
      });
      this.onCancel();
    },
    onSave() {
      this.processInvestMatrix();
    },

    async getMatrix() {
      this.loading = true;
      try {
        const response = await this.$api.get(
          '/invest/GetInvestMatrix?planId=' + this.currentPlanId
        );

        this.investMatrix = response.data;
        this.processTable();
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },
    async updateInvestMatrix() {
      this.loading = true;
      try {
        const model = {
          PlanId: this.currentPlanId,
          Cells: this.investMatrix,
        };
        await this.$api.post('/invest/UpdateInvestmentMatrix', model);

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Saved!',
        });
        this.getMatrix();
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },
    processTable() {
      if (this.investMatrix && this.investMatrix.length > 0) {
        console.log(this.investMatrix);
        const itemKeys = [];
        const items = [];
        this.itemKeys = [];
        const headers = [{ text: '', value: 'StatusGroup' }];
        this.investMatrix[0].forEach((x) => {
          headers.push({ text: x.ContributionType, value: x.ContributionType });
          itemKeys.push(x.ContributionType);
        });
        this.investMatrix.forEach((x) => {
          var row = { StatusGroup: x[0].StatusGroup };
          x.forEach((y) => {
            row[y.ContributionType] = y.Instruction;
          });
          items.push(row);
        });
        this.headers = headers;
        this.items = items;
        this.itemKeys = itemKeys;
      }
    },
    processInvestMatrix() {
      this.investMatrix.forEach((x, m) => {
        console.log(x[0].ContributionType);
        x.forEach((y) => {
          console.log(y);
          console.log(y.ContributionType);
          y.Instruction = this.items[m][y.ContributionType];
        });
      });
      this.updateInvestMatrix();
    },
  },
};
</script>

<style>
.investMatrix {
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;
}

.footerBtnContainer {
  background: white;
  margin-left: 20px;
  margin-right: 20px;
  padding-left: 20px;
  padding-right: 20px;
  box-shadow: 0px -4px 5px 0px #00000040;
}

.v-footer {
  padding: 0px;
}
</style>
